import type { ReactNode } from 'react'
import { navigate } from '../../lib/router'
import { Wordmark } from '../brand/Wordmark'
import { BrandPanel } from './BrandPanel'

/**
 * Two-column auth page: black brand panel left (lg+), form right.
 * Heading on the auth scale, subline muted, content max-w-[400px].
 */
export function AuthLayout({ title, subtitle, panel, children, footer }: {
  title: ReactNode
  subtitle?: ReactNode
  panel: { line1: string; line2: string }
  children: ReactNode
  footer?: ReactNode
}) {
  return (
    <main className="flex min-h-svh bg-background">
      <BrandPanel line1={panel.line1} line2={panel.line2} />
      <div className="flex w-full flex-1 items-center justify-center px-6 py-12 sm:px-10">
        <div className="animate-in mx-auto w-full max-w-[400px]">
          <a
            href="/"
            onClick={(e) => { e.preventDefault(); navigate('/') }}
            className="mb-10 inline-flex lg:hidden"
            aria-label="Doable. Start page"
          >
            <Wordmark />
          </a>
          <h1 className="text-4xl font-normal leading-[1.05] tracking-tight sm:text-5xl">{title}</h1>
          {subtitle ? <p className="mt-3 text-base text-muted-foreground">{subtitle}</p> : null}
          <div className="mt-8">{children}</div>
          {footer ? <div className="mt-6 text-sm text-muted-foreground">{footer}</div> : null}
        </div>
      </div>
    </main>
  )
}
